import React from 'react'
import { connect } from 'react-redux'
import appStore from '../application/appStore'

export function connectWithStore(WrappedComponent, ...args) {
  const ConnectedWrappedComponent = connect(...args)(WrappedComponent)
  return function(props) {
    return <ConnectedWrappedComponent {...props} store={appStore} />
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/connectWithStore.js